/* eslint-disable */
import SceneProvider from "~/scene/provider";

class EmptyVisualiser {}

export default class EmptyMapProvider extends SceneProvider {
	constructor(scene) {
		super(scene, EmptyVisualiser);
	}

	getMap() {
		return null;
	}

	featureChange() {}

	_restoreFromState() {}

	_activate() {
		return Promise.resolve({});
	}

	_deactivate() {
		return Promise.resolve({});
	}
}
